/**
 * Visual-only chrome shared by Popover.Content and any portal-positioned popover that cannot
 * use Radix's portal/positioning (e.g. a popover anchored to viewport coordinates rather than
 * a DOM element). Import this constant and apply it as a className so the visual language stays
 * in sync with Popover.Content without coupling to Radix's positioning machinery.
 */
export const popoverContentClassName = 'bg-surface-overlay-0 rounded-card-md shadow-overlay border border-border-default' as const;
